import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';
import {useI18next, useTranslation} from 'gatsby-plugin-react-i18next';

export const DevSubscribeForm = () => {
  const hubspotFormRef = useRef(null);
  const {t} = useTranslation();
  const {language} = useI18next();

  return (
    <HubspotForm
      locale={language}
      ref={hubspotFormRef}
      portalId='2784460'
      formId='308d2c7c-d0f7-425f-a1ba-d704d0c19405'
      cssClass="position-relative subscribe-form"
      submitButtonClass="btn btn-white position-absolute subscribe-form__btn"
      loading={<div>{t("Loading...")}</div>}
    />
  )
}
